export enum BrowserSizeName {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
